import { render, staticRenderFns } from "./UserChatWindow.vue?vue&type=template&id=d12f24b6&scoped=true&"
import script from "./UserChatWindow.vue?vue&type=script&lang=js&"
export * from "./UserChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./UserChatWindow.vue?vue&type=style&index=0&id=d12f24b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12f24b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSpacer,VTextField})
